const generateRandomNum = arr => {
  return Math.floor(Math.random() * arr.length)
}

export default generateRandomNum
